import { whenElse } from '@genesislcap/foundation-utils';
import { html } from '@microsoft/fast-element';
//   <pre>${(x) => JSON.stringify(x.control, null, 2)}</pre>
function changeHandler(x, c) {
    const inputValue = c.event.target.value;
    x.control.handleChange(x.control.path, inputValue === '' ? null : inputValue);
}
export const getStringControlRendererTemplate = (prefix = 'zero') => html `
  <template>
    <control-wrapper
      :control=${(x) => x.control}
      :touched=${(x) => x.touched}
      ?submitted=${(x) => x.submitted}
    >
      ${whenElse((x) => { var _a, _b; return !((_b = (_a = x.control.uischema) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.textarea); }, html `
          <${prefix}-text-field
            type=${(x) => { var _a, _b; return (((_b = (_a = x.control.uischema) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.isPassword) ? 'password' : 'text'); }}
            :value=${(x) => x.control.data || ''}
            @change=${changeHandler}
            placeholder=${(x) => x.control.uischema.placeholder || x.control.label}
            id=${(x) => x.control.path}
            data-test-id=${(x) => x.control.path}
            ?required=${(x) => x.control.required}
            ?disabled=${(x) => !x.control.enabled}
            style="width: 100%"
            @blur=${(x) => x.onBlur()}
          ></${prefix}-text-field>`, html `
          <${prefix}-text-area
            :value=${(x) => x.control.data || ''}
            @change=${changeHandler}
            placeholder=${(x) => x.control.uischema.placeholder || x.control.label}
            id=${(x) => x.control.path}
            data-test-id=${(x) => x.control.path}
            ?required=${(x) => x.control.required}
            ?disabled=${(x) => !x.control.enabled}
            style="width: 100%"
            @blur=${(x) => x.onBlur()}
          ></${prefix}-text-area>
        `)}
    </control-wrapper>
  </template>
`;
export const StringControlRendererTemplate = html `
  ${(x) => getStringControlRendererTemplate(x.jsonforms.prefix)}
`;
